import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {TrueGritModel} from "../../TrueGritModel";
import {TrueGrit} from "../../TrueGrit";
import {TrueGritScatterSymbol} from "../../reels/TrueGritScatterSymbol";
import {TrueGritGritGirlSymbol} from "../../reels/TrueGritGritGirlSymbol";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TrueGritAvalancheBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController:FlowStateController) {
        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => flowStateController.finish()});

        TrueGrit.anticipationView.resetSoundFlags();

        // #295
        TrueGritModel.previousFSLeft = TrueGrit.model.freespinsLeft;

        // #340
        const allUsedScatters: TrueGritScatterSymbol[] = TrueGrit.trueGritScatterSymbols.getAllUsedScatters();
        allUsedScatters.forEach((sym: TrueGritScatterSymbol) => sym.landedInThisOutcomeForFS = false);
        let anyOldScatterOnReel1: boolean = false;
        for (let i: number = 0; i < allUsedScatters.length; i++) {
            if (allUsedScatters[i].reelId === 0) {
                anyOldScatterOnReel1 = true;

                break;
            }
        }
        if (!anyOldScatterOnReel1) {
            if (allUsedScatters.length === 2 || allUsedScatters.length === 3) {
                gsap.delayedCall(0.5, () => TrueGrit.anticipationView.startScatterReel1Anticipation());
            }
        }

        // #477 -> safe check
        if (!TrueGrit.model.isRestore && allUsedScatters.length > 0) {
            TrueGrit.bottomReelView.startHotZoneAnimation(allUsedScatters.length - 1);
        }

        const allUsedGirls: TrueGritGritGirlSymbol[] = TrueGrit.trueGritGritGirlSymbols.getAllUsedGritGirls();
        if (TrueGrit.model.isRestore) {
            allUsedGirls.forEach((sym: TrueGritGritGirlSymbol) => sym.landedInThisRound = true);
        }
        if (allUsedGirls.length === 2) {
            TrueGritModel.canGritGirlChangeState = true;

            TrueGrit.trueGritGritGirlSymbols.play2GirlsLandedAnimation();

            let anyOldGirlOnReel1: boolean = false;
            for (let i: number = 0; i < allUsedGirls.length; i++) {
                if (allUsedGirls[i].reelId === 0) {
                    anyOldGirlOnReel1 = true;

                    break;
                }
            }
            if (!anyOldGirlOnReel1) {
                gsap.delayedCall(0.5, () => TrueGrit.anticipationView.startGritGirlReel1Anticipation());
            }
        }

        if(tl.duration() == 0) {
            tl.add(gsap.to(this, {duration : 0.001}));
        }
    }
}